import katex from "katex";

/**
 * Render text that may contain KaTeX math delimited by:
 *  - $$...$$ or \[...\]  (block)
 *  - $...$  or \( ... \) (inline)
 *
 * If there are NO delimiters, returns escaped plain text (no KaTeX).
 */
export function renderMath(content) {
  if (content == null) return "";

  const s = String(content);

  try {
    const ESC = (str) =>
      String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");

    // Match any of the supported delimiter blocks (non-greedy)
    const tokenRegex =
      /(\$\$[\s\S]*?\$\$)|(\\\[[\s\S]*?\\\])|(\$(?!\$)[\s\S]*?\$)|(\\\([\s\S]*?\\\))/g;

    // If no delimiters at all => return plain escaped text (NO KaTeX)
    if (!tokenRegex.test(s)) {
      return ESC(s).replace(/\n/g, "<br>");
    }

    // Reset after test() because regex has /g flag
    tokenRegex.lastIndex = 0;

    // Replace each math token with KaTeX HTML; keep other text escaped
    let out = "";
    let lastIndex = 0;

    for (const match of s.matchAll(tokenRegex)) {
      const idx = match.index ?? 0;

      // Add text before token (escaped)
      out += ESC(s.slice(lastIndex, idx)).replace(/\n/g, "<br>");

      const token = match[0];

      // Determine block/inline and strip delimiters
      let displayMode = false;
      let body = token;

      if (token.startsWith("$$") && token.endsWith("$$")) {
        displayMode = true;
        body = token.slice(2, -2);
      } else if (token.startsWith("\\[") && token.endsWith("\\]")) {
        displayMode = true;
        body = token.slice(2, -2);
      } else if (token.startsWith("\\(") && token.endsWith("\\)")) {
        displayMode = false;
        body = token.slice(2, -2);
      } else if (token.startsWith("$") && token.endsWith("$")) {
        displayMode = false;
        body = token.slice(1, -1);
      }

      out += katex.renderToString(body.trim(), {
        displayMode,
        throwOnError: false,
      });

      lastIndex = idx + token.length;
    }

    // Add the remaining tail text (escaped)
    out += ESC(s.slice(lastIndex)).replace(/\n/g, "<br>");

    return out;
  } catch (error) {
    // If KaTeX fails, return escaped content instead of breaking UI
    return String(content)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\n/g, "<br>");
  }
}
